export type BlockField = {
  name: string;
  label: string;
  type: "text" | "textarea" | "url" | "city";
  required?: boolean;
};

export type BlockMeta = {
  label: string;
  description: string;
  fields: BlockField[];
};

export const blockMetadata: Record<string, BlockMeta> = {
  "relocation-carousel": {
    label: "Relocation carousel",
    description: "Related relocation deals carousel.",
    fields: [
      { name: "heading", label: "Heading", type: "text" },
      { name: "originCityId", label: "Origin city", type: "city" },
      { name: "deliveryCityId", label: "Delivery city", type: "city" },
    ],
  },
};
